var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_2774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master_svgk_0_2258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_2774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8485 2.7515C12.3799 2.28287 11.6201 2.28287 11.1515 2.7515L2.75147 11.1515C2.28284 11.6201 2.28284 12.3799 2.75147 12.8486C3.22009 13.3172 3.97989 13.3172 4.44852 12.8486L4.79999 12.4971V20.4C4.79999 21.0628 5.33726 21.6 5.99999 21.6H8.39999C9.06273 21.6 9.59999 21.0628 9.59999 20.4V18C9.59999 17.3373 10.1373 16.8 10.8 16.8H13.2C13.8627 16.8 14.4 17.3373 14.4 18V20.4C14.4 21.0628 14.9372 21.6 15.6 21.6H18C18.6628 21.6 19.2 21.0628 19.2 20.4V12.4971L19.5515 12.8486C20.0201 13.3172 20.7799 13.3172 21.2485 12.8486C21.7171 12.3799 21.7171 11.6201 21.2485 11.1515L12.8485 2.7515Z",
    fill: "url(#paint0_linear_307_2774)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_2774",
    x1: 2.39999,
    y1: 12.1392,
    x2: 21.6,
    y2: 12.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/icon_home_active.7e3150d1a93873feef50687e348530cc.svg";
export { ForwardRef as ReactComponent };